import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ComponentNameTranslationPipe, LevelNameTranslationPipe } from '@twaice-fe/frontend/shared/services';
import { StorageLevel } from '@twaice-fe/shared/models';
import { NzCardComponent } from 'ng-zorro-antd/card';

@Component({
  selector: 'twaice-fe-non-operating-pcs-module-recommendation',
  templateUrl: './non-operating-pcs-module-recommendation.component.html',
  imports: [CommonModule, NzCardComponent, ComponentNameTranslationPipe, LevelNameTranslationPipe],
  styleUrl: './non-operating-pcs-module-recommendation.component.scss',
})
export class NonOperatingPcsModuleRecommendationComponent {
  @Input() componentBk: string;
  @Input() dcCombinerBk: string;
  @Input() enclosureBk: string | null;
  @Input() pcsModuleBks: string[];

  protected readonly storageLevel = StorageLevel;

  constructor(private componentNamePipe: ComponentNameTranslationPipe) {}

  parsePcsModuleBks() {
    return this.pcsModuleBks.map((bk) => this.componentNamePipe.transform(bk)).join(' / ');
  }
}
